import script from "./ODetalhesEventoPlanejado.vue?vue&type=script&lang=ts&setup=true"
export * from "./ODetalhesEventoPlanejado.vue?vue&type=script&lang=ts&setup=true"

import "./ODetalhesEventoPlanejado.vue?vue&type=style&index=0&id=186bbba6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-186bbba6"]])

export default __exports__